// Four long central-block buildings. Cosmetic only; roof details never enter the lanes.
import type {HdBuilding} from '../../common/src/data';
import type {LightFn} from './hd-registry';
import {type G,K,HT,px,frame,bands,disc,text} from './hd-kit';
import {panel,label,fan,pipe,window} from './hd-hachi-study';
export const CENTRAL_STUDY_BUILDINGS=['se-tank','se-office','se-karaoke','se-bar'] as const;
function grille(g:G,x:number,y:number,w:number,h:number){panel(g,x,y,w,h,K.metalLo);for(let j=4;j<h-3;j+=5)px(g,x+3,y+j,w-6,1,K.metalHi);}
function rail(g:G,x:number,y:number,w:number){px(g,x,y,w,2,K.metalHi);for(let j=0;j<w;j+=10)px(g,x+j,y,2,15,K.metalLo);px(g,x,y+14,w,3,K.metal);}
export function paintKabukiCentral(g:G,b:HdBuilding,x:number,y:number,L:LightFn){
 if(!(CENTRAL_STUDY_BUILDINGS as readonly string[]).includes(b.id))return;
 const w=b.w*HT,h=b.h*HT,rh=(b.h-b.face)*HT,fy=y+rh;
 g.save();g.beginPath();g.rect(x,y,w,h);g.clip();
 // A narrow maintenance spine ties the long roof together without painting a street.
 px(g,x+w-24,y+18,9,rh-38,K.metalLo);for(let j=22;j<rh-22;j+=12)px(g,x+w-23,y+j,7,1,K.metalHi);
 pipe(g,x+12,y+161,135);
 if(b.id==='se-tank'){
  panel(g,x+30,y+174,w-74,92,K.concreteLo);grille(g,x+41,y+188,w-96,61);
  for(const yy of [y+179,y+255])px(g,x+34,yy,w-82,3,K.metalHi);
  // Reinforced service gantry and paired circulation fans around the retained tank.
  panel(g,x+31,y+342,w-72,76,K.metalLo);fan(g,x+43,y+353);fan(g,x+81,y+353);
  px(g,x+47,y+383,w-109,12,K.metal);px(g,x+49,y+384,w-113,2,K.metalHi);
  rail(g,x+28,y+422,w-66);label(g,'SERVICE',x+53,y+451,w-108,K.white);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,6);
  for(let j=0;j<3;j++){const xx=x+10+j*69;grille(g,xx,fy+11,62,48);px(g,xx+6,fy+51,50,3,K.amber);}
  L(x+17,fy+51,w-34,3,K.amber,.14,true);
 }else if(b.id==='se-office'){
  panel(g,x+33,y+180,w-72,92,K.concreteLo);window(g,x+43,y+191,w-92,57,K.glassLo);
  for(let j=1;j<4;j++)px(g,x+43+j*33,y+193,2,53,K.metalHi);
  px(g,x+43,y+253,w-92,5,K.metalLo);
  panel(g,x+33,y+362,w-72,64,K.metalLo);for(let j=0;j<3;j++){grille(g,x+40+j*43,y+370,36,47);}
  label(g,'OFFICE',x+49,y+454,w-104,K.white,2);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.concrete,K.wallLo,6);
  for(const xx of [x+14,x+w-66])window(g,xx,fy+17,52,36,K.glassLo);
  window(g,x+w/2-21,fy+16,42,44,K.amber);px(g,x+w/2-1,fy+19,2,37,K.metalLo);
  px(g,x+9,fy+8,w-18,4,K.metalHi);L(x+w/2-16,fy+24,32,30,K.amber,.13,true);
 }else if(b.id==='se-karaoke'){
  // Soundproof plant room, acoustic louvers and a restrained rooftop identity.
  panel(g,x+30,y+190,w-72,88,K.wallLo);grille(g,x+41,y+202,45,61);label(g,'AUDIO',x+104,y+219,91,K.white,2);
  panel(g,x+35,y+335,w-83,73,K.metalLo);for(let j=0;j<4;j++){window(g,x+42+j*38,y+343,31,54,j%2?K.glassLo:K.pink);}
  rail(g,x+30,y+413,w-72);label(g,'カラオケ',x+34,y+452,w-76,K.pink,2);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.wall,K.wallLo,6);
  label(g,'カラオケ',x+45,fy+5,w-90,K.pink,2);
  window(g,x+w/2-20,fy+34,40,27,K.pink);
  for(const xx of [x+14,x+w-66]){window(g,xx,fy+34,52,22,K.amber);px(g,xx+5,fy+36,8,18,K.woodLo);px(g,xx+39,fy+36,8,18,K.woodLo);}
  L(x+50,fy+11,w-100,16,K.pink,.22,true);
 }else{
  // Staff roof terrace stays enclosed; the street bar remains the only implied frontage.
  panel(g,x+31,y+174,w-72,114,K.woodLo);for(let j=5;j<109;j+=10)px(g,x+35,y+174+j,w-80,1,K.woodHi);
  rail(g,x+33,y+176,w-76);rail(g,x+33,y+273,w-76);
  for(const xx of [x+75,x+169]){disc(g,xx,y+227,19,10,K.woodHi);px(g,xx-2,y+235,4,12,K.woodLo);for(const dx of [-26,26]){disc(g,xx+dx,y+235,7,4,K.metalHi);px(g,xx+dx-2,y+239,2,8,K.metalLo);}}
  panel(g,x+35,y+356,w-80,68,K.concreteLo);fan(g,x+44,y+366);fan(g,x+82,y+366);grille(g,x+126,y+366,72,47);
  label(g,'バー',x+63,y+456,w-136,K.pink,2);
  bands(g,x+2,fy+2,w-4,h-rh-4,K.woodHi,K.woodLo,6);for(let j=8;j<w-8;j+=13)px(g,x+j,fy+4,2,55,K.woodLo);
  window(g,x+w/2-19,fy+15,38,45,K.amber);
  for(const xx of [x+14,x+w-90]){window(g,xx,fy+21,76,31,K.amber);for(let j=9;j<69;j+=13){px(g,xx+j,fy+32,5,13,K.woodLo);px(g,xx+j+1,fy+29,2,4,K.metalHi);}px(g,xx+3,fy+45,70,3,K.woodHi);}
  px(g,x+9,fy+8,w-18,3,K.pink);L(x+13,fy+9,w-26,3,K.pink,.16,true);
 }
 frame(g,x+2,fy+2,w-4,h-rh-4,K.ink);px(g,x+2,y+h-4,w-4,3,K.ink);g.restore();
}
